import React, {useState} from 'react';
import {Box, Typography, Modal, Button} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { DateTime } from 'luxon';
import { ReactComponent as Ellipses } from '../../../assets/images/ellipsis-solid.svg';
import EastIcon from '@mui/icons-material/East';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import AddLinkOutlinedIcon from '@mui/icons-material/AddLinkOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom'; // for internal routing

const SnackBarWithMenu = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // const {snackBarInfo} = props;
  const [menu, setMenu] = useState(false);
  const [activeModal, setActiveModal] = useState(null);

  let snackBarInfo = {
    backgroundColor:'#1A1C1E',
    textColor:'#fff',
    textLineOne:'The Tri-State PGA',
    textLineTwo:'2025 Team Golf League',
    menuItems: [
      {
        modal: 'prize',
        text: 'Prize info'
      },
      {
        modal: 'foundation',
        text: 'REACH foundation'
      },
      {
        modal: 'partners',
        text: 'Partner links'
      },
      {
        modal: 'share',
        text: 'Share'
      },
    ]
  }
  // If snackBarInfo is missing or empty, return null (don't render anything)
  if (!snackBarInfo || Object.keys(snackBarInfo).length === 0) {
    return null;
  }

  const {backgroundColor, textColor, textLineOne, textLineTwo, url, expirationDate, menuItems} = snackBarInfo;

  // Check if the snackBar has expired
  if (expirationDate) {
    // Get current time in Eastern Time
    const currentDate = DateTime.now().setZone('America/New_York');

    // Parse expiration date as Eastern Time
    // Assuming expirationDate is provided in ISO format or a format Luxon can parse
    const expireDate = DateTime.fromISO(expirationDate, { zone: 'America/New_York' });

    // If current date is after expiration date, don't render the snackbar
    if (currentDate > expireDate) {
      return null;
    }
  }

  const SubMenu = ({ menuItems }) => {
    return (
      <Box sx={{
        background:'#fff',
        color:'#373737',
        fontWeight:'400',
        position:'absolute',
        zIndex:7,
        top:isMobile? '163px': '215px',
        right: 0,
        left: 'auto',
        width:'138px',
        height:'149px', //CHANGE TO 171 WHEN ADDING ANOTHER NAV ITEM
        textAlign:'left',
        lineHeight:'1.4',
        paddingTop:'16px',
        paddingLeft: '10px',
        boxShadow:'0 0 15px #000'

      }}>
        {menuItems.map((item, index) => (
          <Box
            key={index}
            sx={{ marginBottom: '16px', cursor: 'pointer' }}
            onClick={() => {
              setActiveModal(item.modal);
              setMenu(false); // close menu after click
            }}
          >
            <Typography sx={{ fontSize: '12px' }}>{item.text}</Typography>
          </Box>
        ))}
      </Box>
    );
  };
  const PrizeModal = ({ open, onClose }) => (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Box sx={modalHeaderStyle}>
          <Typography sx={{ fontWeight: '700', fontSize: '24px' }}>Prize information</Typography>
          <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
        </Box>

        <Typography sx={{ fontWeight: '400', marginBottom: '24px' }}>
          The Top 3 Teams with the best team stroke play score will collect prize pool payouts and trophies.
        </Typography>
        <Typography sx={{ fontWeight: '400', marginBottom: '24px' }}>
          A <span style={{ fontWeight: '800' }}>$10,000 prize pool</span> has been added to the professional purse.
        </Typography>
        <Typography sx={{ fontWeight: '400', marginBottom: '24px' }}>
          The winning teams' purse will be evenly distributed among the team members.
        </Typography>
      </Box>
    </Modal>
  );

  const FoundationModal = ({ open, onClose }) => (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Box sx={modalHeaderStyle}>
          <Typography sx={{ fontWeight: '700', fontSize: '24px' }}>REACH Foundation</Typography>
          <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
        </Box>

        <img style={{ display: 'block', margin: '0 auto' }} src="https://poolpartyfilestorage.blob.core.windows.net/media/PGA-REACH-TRI-STATE-.png" alt='PGA of America Reach Foundation, Tri-State'/>
        <Typography sx={{ fontWeight: '700', textAlign: 'center', marginBottom: '20px', marginTop: '20px' }}>
          PGA of America REACH Foundation Tri-State is a charitable foundation, focused on three key pillars to grow the game of golf throughout our section.
        </Typography>
        <Typography sx={{ fontWeight: '700', textAlign: 'center' }}>
          These pillars will include Youth Golf, the PGA HOPE Program, and Inclusion-based programs to provide golf to all!
        </Typography>
        <Button
          sx={{
            margin: '25px auto',
            display: 'block',
            padding: '4px 12px'
          }}
          className="my-pools-card-button"
          onClick={() => {
            window.open('https://tristate.pga.com/foundation/', '_blank', 'noopener,noreferrer');
          }}
        >
          Donate to REACH Foundation <EastIcon sx={{ fontSize: '16px', marginBottom: '1px' }} />
        </Button>
      </Box>
    </Modal>
  );


  const PartnersModal = ({ open, onClose }) => (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Box sx={modalHeaderStyle}>
          <Typography sx={{ fontWeight: '700', fontSize: '24px' }}>Partner Links</Typography>
          <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
        </Box>

        <MuiLink
          href="https://tristate.pga.com/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: '#00AAD1', display: 'block', marginBottom: '10px', textDecoration:'underline' }}
        >
          Tri-State PGA
        </MuiLink>
        <MuiLink
          href="https://tristate.pga.com/foundation/"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ color: '#00AAD1', display: 'block', marginBottom: '10px', textDecoration:'underline' }}
        >
          REACH Foundation
        </MuiLink>
        <MuiLink
          component={RouterLink}
          to="/private-pools"
          sx={{ color: '#00AAD1', display: 'block', marginBottom: '10px', textDecoration:'underline'  }}
        >
          The Birdie Battle (Coming Soon)
        </MuiLink>
      </Box>
    </Modal>
  );


  const ShareModal = ({ open, onClose }) => {
    const url = window.location.href;

    const copyToClipboard = async () => {
      try {
        await navigator.clipboard.writeText(url);
        alert('Link copied to clipboard!');
      } catch (err) {
        console.error('Failed to copy: ', err);
      }
    };

    const openSMS = () => {
      const smsBody = encodeURIComponent(`Check this out: ${url}`);
      window.location.href = `sms:?body=${smsBody}`;
    };

    const openEmail = () => {
      const subject = encodeURIComponent('Check out this league');
      const body = encodeURIComponent(`Here’s the link: ${url}`);
      window.location.href = `mailto:?subject=${subject}&body=${body}`;
    };

    return (
      <Modal open={open} onClose={onClose}>
        <Box sx={modalStyle}>
          <Box sx={modalHeaderStyle}>
            <Typography sx={{ fontWeight: '700', fontSize: '24px' }}>Share this league</Typography>
            <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'space-around', flexDirection: 'row', gap: 2 }}>
            <Box sx={shareItemStyle} onClick={copyToClipboard}>
              <AddLinkOutlinedIcon sx={{ width: '45px', height: 'auto' }} />
              <Typography>Copy Link</Typography>
            </Box>
            <Box sx={shareItemStyle} onClick={openSMS}>
              <ChatOutlinedIcon sx={{ width: '45px', height: 'auto' }} />
              <Typography>Text</Typography>
            </Box>
            <Box sx={shareItemStyle} onClick={openEmail}>
              <EmailOutlinedIcon sx={{ width: '45px', height: 'auto' }} />
              <Typography>Email</Typography>
            </Box>
          </Box>
        </Box>
      </Modal>
    );
  };


  const shareItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
    padding: '8px',
    borderRadius: '4px',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    }
  };

  // Style for modal content box
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width:'325px',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '22px',
    boxShadow: 24,
    borderColor:'#e5e7eb !important',
    borderRadius: '8px'
  };

  const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px'
  };

  // Define common box styles
  const boxStyles = {
    // position: 'fixed',
    top: isMobile ? 80 : 136,
    left: 0,
    zIndex: 8,
    backgroundColor: backgroundColor,
    width: '100%',
    padding: '16px',
    paddingTop: '22px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: textColor,
    fontSize: isMobile ? '12px' : '16px',
    fontWeight: 700,
    textAlign:'left'
  };

  // Conditionally render either a Link or a Box based on URL presence
  return(
    <>
      {/* SNACK BAR */}
      <Box sx={boxStyles}>
        <Box>
          <Typography sx={{fontWeight:800}}>{textLineOne}</Typography>
          <Typography>{textLineTwo}</Typography>
        </Box>
        <Box sx={{width:'18px'}}>
          <Ellipses onClick={()=> setMenu(!menu)}/>
        </Box>
      </Box>
      {menu && (
        <SubMenu menuItems={menuItems} />
      )}

      {activeModal === 'prize' && <PrizeModal open={true} onClose={() => setActiveModal(null)} />}
      {activeModal === 'foundation' && <FoundationModal open={true} onClose={() => setActiveModal(null)} />}
      {activeModal === 'partners' && <PartnersModal open={true} onClose={() => setActiveModal(null)} />}
      {activeModal === 'share' && <ShareModal open={true} onClose={() => setActiveModal(null)} />}

    </>
  );
}

export default SnackBarWithMenu;